import {
  BrowseEnrichmentRequest,
  useBrowseEnrichmentApi,
} from '@aibees/elephant/api/enrichment/use-browse-enrichment-api';
import { EnrichmentTypeFilter } from '@aibees/elephant/components/enrichment-type-filter';
import { DownloadEnrichRecord } from '@aibees/elephant/feature/enrichment-table/components/download-enrich-record';
import { EnrichmentFileName } from '@aibees/elephant/feature/enrichment-table/components/enrichment-file-name';
import { EnrichmentType } from '@aibees/elephant/feature/enrichment-table/components/enrichment-type';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import {
  DateTime,
  TableCellTypography,
  TextEllipsis,
} from '@aibees/shared/components';
import { Enrichment } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import {
  DATE_FORMAT_YYYY_MM_DD_hh_mm_a,
  userGetShortName,
} from '@aibees/shared/utils';
import { EnrichmentSearchTableAction } from './actions/enrichment-search-table-action';
import { EnrichSearchFilter } from './filters/enrich-search-filter';
import * as SX from './sx';

export const config: AdvanceTableConfig<Enrichment, BrowseEnrichmentRequest> = {
  rowKey: 'id',
  columns: [
    {
      id: 'name',
      label: 'File Name',
      sortable: true,
      width: 120,
      render: (_, v) => <EnrichmentFileName item={v} />,
    },
    {
      id: 'type',
      label: 'Type',
      sortable: 'type',
      width: 96,
      render: (_, v) => <EnrichmentType type={v.type} />,
    },
    {
      id: 'records',
      label: 'Total',
      sortable: true,
      width: 70,
      render: (_, v) => (
        <TableCellTypography
          item={`${v.statistics.matched} / ${v.statistics.total}`}
        />
      ),
    },
    {
      id: 'workspace',
      label: 'Team',
      sortable: true,
      width: 80,
      render: (_, v) => (
        <TextEllipsis>
          <TableCellTypography item={userGetShortName(v.workspace.user)} />
        </TextEllipsis>
      ),
    },
    {
      id: 'modified',
      label: 'Last Modified',
      sortable: true,
      width: 114,
      render: (v, d) => (
        <DateTime
          value={v ?? d.modified}
          format={DATE_FORMAT_YYYY_MM_DD_hh_mm_a}
        />
      ),
    },
    {
      id: 'status',
      label: 'Status',
      sortable: 'status',
      width: 100,
      render: (_, v) => <DownloadEnrichRecord item={v} />,
      align: 'center',
    },
  ],
  actions: [EnrichmentSearchTableAction],
  browseApi: useBrowseEnrichmentApi,
  initialFilters: { type: EnrichmentTypeEnum.ALL },
  filters: [EnrichSearchFilter, EnrichmentTypeFilter],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  },
  stickyHeader: true,
  defaultOrderBy: 'modified',
  hideColumnsOnNoData: true,
  showTablePrependOnNotFound: true,
  emptyProps: {
    emptyIcon: 'view-in-ar',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { px: 0.5, py: 1 },
  bordered: 'solid',
  rowsPerPageOptions: [5],
  showJumpToPage: false,
  showPageSelector: false,
  filtersSx: {
    flexDirection: 'row !important',
    '& .EnrichSearchFilter': { flex: 2 },
  },
};
